<body>
    <div class="container">
        <div class="top">
            <div class="left">
                <div *ngFor="let range of ranges">
                    <button [ngClass]="range['focus']?'focus':null"> <img src="assets/images/decrease.png"
                            (click)="changeRange(range['label'],false)" alt="decrease"></button>
                    <button [ngClass]="range['focus']?'focus':null"
                        (click)="updateRangesCalendar(range['label'],true)">{{range['label']}}</button>
                    <button [ngClass]="range['focus']?'focus':null"><img src="assets/images/increase.png"
                            (click)="changeRange(range['label'],true)" alt="increase"></button>
                </div>
            </div>
            <div class="right">
                <ngx-daterangepicker-material [id]="id" [autoApply]="true" [linkedCalendars]="true"
                    (choosedDate)="choosedDate($event)" [startDate]="selected.startDate"
                    [endDate]="selected.endDate" [locale]="locale" [minDate]="limits.minDate" [maxDate]="limits.maxDate">
                </ngx-daterangepicker-material>
            </div>
        </div>
        <div class="bottom">
            <div class="sort">
                <span>View by</span>
                <img [src]="requestDate ? 'assets/images/check-box.png' : 'assets/images/checkbox-blank-circle-outline.png'"
                    (click)="viewBy(true)" alt="check-box">
                <span class="label" [ngClass]="responseDate?'dull':null">Request date</span>
                <img [src]="responseDate ? 'assets/images/check-box.png' : 'assets/images/checkbox-blank-circle-outline.png'"
                    (click)="viewBy(false)" alt="blank">
                <span class="label" [ngClass]="requestDate?'dull':null">Response date</span>
            </div>
            <div class="actions">
                <button class="reset" (click)="reset()">Reset</button>
                <button class="apply" (click)="apply()">Apply</button>
            </div>
        </div>
    </div>
</body>